import './product-cards.scss';

class ProductCards {
    constructor (element) {
        this.$productCard = element;
        this.$itemsTo1 = element.querySelectorAll('[data-product-cards-pos="1"]');
        this.$itemsTo2 = element.querySelectorAll('[data-product-cards-pos="2"]');
        this.$content1 = element.querySelector('[data-product-cards-content="1"]');
        this.$content2 = element.querySelector('[data-product-cards-content="2"]');
        this.$processSelect = element.querySelector('[data-product-cards="process-select"]');
        this.$processViewButton = this.$processSelect?.querySelector('[data-product-cards="process-view"]');
        this.$$selectedProcesses = this.$productCard.querySelectorAll('input[type="checkbox"]:checked');
        this.buttonDisabled = true;
    }

    initialize () {
        this.toggleVersion();
        this.checkSize();
        this.toggleDisabledState();
        this.setEvents();
        this.setProcessSelectWidth();
    }

    moveIn () {
        this.$itemsTo1.forEach(($item) => {
            this.$content1.appendChild($item);
        });

        this.$itemsTo2.forEach(($item) => {
            this.$content2.appendChild($item);
        });
    }

    moveOut () {
        this.$itemsTo1.forEach(($item) => {
            this.$productCard.insertBefore($item, this.$content2);
        });

        this.$itemsTo2.forEach(($item) => {
            this.$productCard.insertBefore($item, this.$content2);
        });
    }

    checkSize () {
        if (window.mediaMatchHandler[1280].matches) {
            this.moveIn();
        }

        window.mediaMatchHandler[1280].addEventListener('change', (match) => {
            if (!match.matches) {
                this.moveOut();
            }

            if (match.matches) {
                this.moveIn();
            }
        });
    }

    viewProcesses () {
        const isValidURL = (value) => {
            try {
                const url = new URL(value); // eslint-disable-line
                return true;
            } catch (e) {
                return false;
            }
        };

        this.$$selectedProcesses.forEach($selectedProcess => {
            const isValidUrl = isValidURL($selectedProcess.value);
            if (isValidUrl) {
                window.open($selectedProcess.value, '_blank');
            }
        });
    }

    toggleVersion () {
        if (window.popupBlockerActive) {
            this.$productCard.setAttribute('data-popupblocker-activated', '');
        }
    }

    setProcessSelectWidth () {
        if (!window.popupBlockerActive || !this.$processSelect) {
            return;
        }

        const $fakeOptions = this.$processSelect.querySelector('[data-multiselect="fake-options"]');
        const $actionButton = this.$productCard.querySelector('[data-product-cards="process-actions"] a');
        const mediaMatch = window.mediaMatchHandler && window.mediaMatchHandler[1280];

        if (!$fakeOptions || !mediaMatch) {
            return;
        }

        const measure = ($element, extraStyles = {}) => {
            const previous = {};

            Object.keys(extraStyles).forEach((property) => {
                previous[property] = $element.style[property];
                $element.style[property] = extraStyles[property];
            });

            previous.width = $element.style.width;
            $element.style.width = 'max-content';

            const width = Math.ceil($element.getBoundingClientRect().width);

            Object.keys(previous).forEach((property) => {
                $element.style[property] = previous[property];
            });

            return width;
        };

        const measureOptions = () => {
            const previousAria = $fakeOptions.getAttribute('aria-hidden');
            const previous = {
                display: $fakeOptions.style.display,
                flexDirection: $fakeOptions.style.flexDirection,
                visibility: $fakeOptions.style.visibility,
                width: $fakeOptions.style.width
            };

            $fakeOptions.setAttribute('aria-hidden', 'false');
            $fakeOptions.style.display = 'flex';
            $fakeOptions.style.flexDirection = 'column';
            $fakeOptions.style.visibility = 'hidden';
            $fakeOptions.style.width = 'max-content';

            const width = $fakeOptions.offsetWidth;

            if (previousAria === null) {
                $fakeOptions.removeAttribute('aria-hidden');
            } else {
                $fakeOptions.setAttribute('aria-hidden', previousAria);
            }
            Object.keys(previous).forEach((property) => {
                $fakeOptions.style[property] = previous[property];
            });

            return width;
        };

        const applyWidth = () => {
            if (!mediaMatch.matches) {
                this.$productCard.style.removeProperty('--process-select-width');
                return;
            }

            const optionsWidth = measureOptions();
            const buttonWidth = $actionButton ? measure($actionButton) : 0;
            const width = Math.max(optionsWidth, buttonWidth);

            this.$productCard.style.setProperty('--process-select-width', `${width}px`);
        };

        applyWidth();
        mediaMatch.addEventListener('change', applyWidth);
    }

    toggleDisabledState () {
        if (this.buttonDisabled) {
            if (this.$$selectedProcesses.length > 0) {
                this.buttonDisabled = false;
                this.$processViewButton.classList.remove('button--disabled');
                this.$processViewButton.disabled = false;
            }
        } else {
            if (this.$$selectedProcesses.length === 0) {
                this.buttonDisabled = true;
                this.$processViewButton.classList.add('button--disabled');
                this.$processViewButton.disabled = true;
            }
        }
    }

    setEvents () {
        if (this.$processSelect) {
            this.$processSelect.addEventListener('change', () => {
                this.$$selectedProcesses = this.$productCard.querySelectorAll('input[type="checkbox"]:checked');
                this.toggleDisabledState();
            });

            if (this.$processViewButton && !window.popupBlockerActive) {
                this.$processViewButton.addEventListener('click', () => {
                    this.viewProcesses();
                });
            }
        }
    }
}

export { ProductCards };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $productCards = $context.querySelectorAll('[data-product-cards="item"]');

        if ($productCards.length > 0) {
            $productCards.forEach($productCard => {
                $productCard = new ProductCards($productCard);
                $productCard.initialize();
            });
        }
    }
});
